import React from "react";
import { Line } from "react-chartjs-2";
import styles from "./Historical.module.css";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from "chart.js";
import Card from "@/components/common/card/Card";
import { useHistoricalChart } from "./useHistoricalChart";
import type { simulation } from "@/features/dashboard/types.api";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
);

const HistoricalDataCard: React.FC<{ simulations: simulation[] }> = ({
    simulations,
}) => {
    const { lineChartData, lineChartOptions } = useHistoricalChart(simulations);

    return (
        <Card title="Histórico de puntajes" icon="📅" id="historical">
            {!simulations || simulations.length === 0 ? (
                <p className={styles["no-data"]}>
                    No hay datos históricos disponibles.
                </p>
            ) : (
                <div className={styles["chart-container"]}>
                    <Line data={lineChartData} options={lineChartOptions} />
                </div>
            )}
        </Card>
    );
};

export default HistoricalDataCard;
